// Step 1: Define TypeScript interfaces for type safety
export interface PamsAttachment {
  id?: string;
  name: string;
  size: number;
  contentType: string;
  content: string; // Base64 encoded content
  hash: string; // MD5 or SHA256 hash for duplicate detection
  emailId: string;
  emailSubject: string;
  uploadDate: string;
  source: "outlook" | "compose" | "read";
}

export interface AttachmentProcessResult {
  success: boolean;
  message: string;
  attachmentId?: string;
  isDuplicate?: boolean;
  error?: string;
}
export interface OutlookAttachment {
  attachmentType: string;
  contentType: string;
  id: string;
  isInline: boolean;
  name: string;
  size: number;
}

export interface PamsApiResponse {
  success: boolean;
  message: string;
  data?: any;
  error?: string;
}
export enum RelatedToTypes {
  All = 0,
  File = 1,
  Job = 2,
  Project = 3,
  Client = 4, //Account
  AccountLead = 5,
  Employee = 6,
  CompanyBranch = 7,
  Task = 8,
  Activity = 9,
  User = 10,
  JobItem = 11,
  clientDelay = 12,
  Invoice = 13,
  Payment = 14,
  Contact = 15,
  LeadContact = 16,
  ArchivedJob = 17,
  PurchaseJob = 18, //buyout
  AccountRegistration = 19,
  ProjectRegistration = 20,
  lettersOfGuaranties = 21,
  Products = 22,
  MRQ = 23,
  Procurement = 24,
  InspectionSheet = 25,
  InspectionProduct = 26,
  InspectionDefect = 27,
  StoreProduct = 28,
  ReceivedShipment,
  ExternalServiceOrder,
  ProductionOrder,
  TransferOrder,
  ShippedOrder,
  IssueNote,
  DeliveryNote,
  PrincipalInvoice,
  PurchaseInvoice,
}
export class CheckAttachmentWithFilesResponse {
  OutlookId: string;
  LinkedTo: [
    {
      RelatedToTypeId: number;
      RelatedToId: number;
      RelatedToNo: string;
    },
  ];
}
export function returnRelatedToTypes(enumId: number): string {
  switch (enumId) {
    case RelatedToTypes.File:
      return "File";
    case RelatedToTypes.Job:
      return "Sales";
    case RelatedToTypes.Project:
      return "Project";
    default:
      return "";
  }
}
export const TypesList: { Name: string; ID: number }[] = [
  //, { Name: "Employee", ID: RelatedToTypes.Employee }
  { Name: "Sales jobs", ID: RelatedToTypes.Job },
  { Name: "Buyout", ID: RelatedToTypes.PurchaseJob },
  { Name: "Purchasing", ID: RelatedToTypes.Procurement },
  { Name: "Project", ID: RelatedToTypes.Project },
  { Name: "Invoice", ID: RelatedToTypes.Invoice },
  { Name: "Payment", ID: RelatedToTypes.Payment },
  { Name: "Account", ID: RelatedToTypes.Client },
  { Name: "Contacts", ID: RelatedToTypes.Contact },
  { Name: "Task", ID: RelatedToTypes.Task },
  { Name: "Activity", ID: RelatedToTypes.Activity },
  { Name: "User", ID: RelatedToTypes.User },
  { Name: "Inspected product", ID: RelatedToTypes.InspectionProduct },
  //{ Name: "Inspected defect", ID: RelatedToTypes.InspectionDefect },
  { Name: "L/G", ID: RelatedToTypes.lettersOfGuaranties },
  { Name: "MRQ", ID: RelatedToTypes.MRQ },
  { Name: "Account regisration", ID: RelatedToTypes.AccountRegistration },
  { Name: "Project regisration", ID: RelatedToTypes.ProjectRegistration },
  //, { Name: "Vendor", ID: RelatedToTypes.Vendor }
];
export const TypesListForActivity: { Name: string; ID: number }[] = [
  { Name: "-- Select tag --", ID: 0 },
  //, { Name: "Employee", ID: RelatedToTypes.Employee }
  { Name: "Sales jobs", ID: RelatedToTypes.Job },
  { Name: "Invoice", ID: RelatedToTypes.Invoice },
  { Name: "L/G", ID: RelatedToTypes.lettersOfGuaranties },
  //{ Name: "Buyout", ID: RelatedToTypes.PurchaseJob },
  { Name: "Purchasing", ID: RelatedToTypes.Procurement },
  { Name: "Project", ID: RelatedToTypes.Project },
  //{ Name: "Payment", ID: RelatedToTypes.Payment },
  { Name: "Account", ID: RelatedToTypes.Client },
  { Name: "Contacts", ID: RelatedToTypes.Contact },
  //{ Name: "Task", ID: RelatedToTypes.Task },
  //{ Name: "Activity", ID: RelatedToTypes.Activity },
  //{ Name: "User", ID: RelatedToTypes.User },
  //{ Name: "Inspected product", ID: RelatedToTypes.InspectionProduct },
  //{ Name: "Inspected defect", ID: RelatedToTypes.InspectionDefect },
  //{ Name: "MRQ", ID: RelatedToTypes.MRQ },
  //{ Name: "Account regisration", ID: RelatedToTypes.AccountRegistration },
  //{ Name: "Project regisration", ID: RelatedToTypes.ProjectRegistration },
];
export class PamsFileData {
  FileID: number;
  FileName: string; //old name
  FileTitle: string; //new name use defined
  WebFullName: string;
  NameSuffix: string;
  WebId: string;
  WebParentId: string;
  WebUrl: string;
  Users: DriveUser[];
  CloudItemId: string;
  CloudItemPath: string;
  CloudTypeId: number;
  OutlookItemId: string;
  ParentFileID: number;
  FileType: string;
  FileTypeId: number;
  FileCategoryId: number;
  FilePath: string;
  UploadedFileID: string;
  SizeInBytes: number;
  CreationDate: Date;
  ModificationDate: Date;
  CreatedByID: number;
  ModificatedByID: number;
  CompanyBranchID: number;
  CompanyID: number;
  UserId: number;
  selected: boolean = false;
  IsDefaultLibrary: boolean;
  FileTags: Tag[] = [];
  VersionNo: number;
  //FileComments: Comment[] = [];
  _FilesRoles: FilesRoles[] = [];
  _LibraryPermision: FilesRoles;
}
export class DriveUser {
  Id: number;
  BranchId: number;
  Name: string;
  Email: string;
  CanEdit: boolean;
  CanView: boolean;
}
export class Tag {
  TagID: number;
  TagTitle: string;
  TagContent: string;
  ReferenceToID: number;
  ReferenceToTypeID: number;
  TaskID: number;
  ActivityID: number;
  TagRelatedToID: number;
  TagRelatedTypeID: number;
  _companyBranchId: number;
  _ReferenceToTypeName: string;
}
export class FilesRoles {
  NewRole: boolean = false;
  EditRole: boolean = false;
  ViewRole: boolean = false;
  DeleteRole: boolean = false;
  UploadRole: boolean = false;
  DownloadRole: boolean = false;
  RoleName: string;
  RoleId: number;
  FileId: number;
  Id: number;
  _selectAll: boolean = false;
}
export class OneDriveFilesList {
  id: string;
  parentItemId: string;
  name: string;
  title: string;
  fileLength: number;
  webUrl: string;
  isFile: boolean;
  expanded: boolean;
  selected: boolean;
  hasItems: boolean;
  items?: OneDriveFilesList[] = [];
}
export class TagsList{
Accounts: string;
ID: number;
ItemNo: string;
Name: string;
Title: string
}